var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareSemibold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6C21 8.20914 19.2091 10 17 10C14.7909 10 13 8.20914 13 6C13 3.79086 14.7909 2 17 2C19.2091 2 21 3.79086 21 6ZM17 8.5C18.3807 8.5 19.5 7.38071 19.5 6C19.5 4.61929 18.3807 3.5 17 3.5C15.6193 3.5 14.5 4.61929 14.5 6C14.5 7.38071 15.6193 8.5 17 8.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 18C21 20.2091 19.2091 22 17 22C14.7909 22 13 20.2091 13 18C13 15.7909 14.7909 14 17 14C19.2091 14 21 15.7909 21 18ZM17 20.5C18.3807 20.5 19.5 19.3807 19.5 18C19.5 16.6193 18.3807 15.5 17 15.5C15.6193 15.5 14.5 16.6193 14.5 18C14.5 19.3807 15.6193 20.5 17 20.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9833 14.6646L13.244 16.6211C13.4196 16.1431 13.6838 15.7078 14.0167 15.3354L10.756 13.3789C10.9138 12.9491 11 12.4846 11 12C11 11.5154 10.9138 11.0509 10.756 10.6211L14.0167 8.66463C13.6838 8.29215 13.4196 7.85695 13.244 7.37894L9.98329 9.33537C9.25081 8.51585 8.18565 8 7 8C4.79086 8 3 9.79086 3 12C3 14.2091 4.79086 16 7 16C8.18565 16 9.25081 15.4841 9.9833 14.6646ZM9.5 12C9.5 13.3807 8.38071 14.5 7 14.5C5.61929 14.5 4.5 13.3807 4.5 12C4.5 10.6193 5.61929 9.5 7 9.5C8.38071 9.5 9.5 10.6193 9.5 12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareSemibold);
export default __webpack_public_path__ + "static/media/share-semibold.8e60d19442e166d7b3eefc18dd9bedde.svg";
export { ForwardRef as ReactComponent };